exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.domainSelect[data-v-3d2fdae2] {\n\tmargin-top: 0.4em;\n}\n.emailText[data-v-3d2fdae2] {\n\ttext-align: right;\n}\n", ""]);

// exports
